import { render, staticRenderFns } from "./SubProductsOverlay.vue?vue&type=template&id=48a0501c&scoped=true"
import script from "./SubProductsOverlay.vue?vue&type=script&lang=js"
export * from "./SubProductsOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0501c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a0501c')) {
      api.createRecord('48a0501c', component.options)
    } else {
      api.reload('48a0501c', component.options)
    }
    module.hot.accept("./SubProductsOverlay.vue?vue&type=template&id=48a0501c&scoped=true", function () {
      api.rerender('48a0501c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubProductsOverlay.vue"
export default component.exports